import { useEffect } from "react";
import { motion } from "framer-motion";
import { FandomQuiz } from "@/components/FandomQuiz";
import { CharacterGallery } from "@/components/CharacterGallery";
import { PairSets } from "@/components/PairSets";
import { RevealLines } from "@/components/Reveal";

const Cover = ({ src, alt, glow, border, testid }) => (
  <motion.div initial={{ opacity: 0, y: 40, rotate: 0 }} animate={{ opacity: 1, y: 0, rotate: -3 }}
    transition={{ duration: 1.1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
    className="relative mx-auto w-full max-w-[340px] lg:max-w-[400px]">
    <div className="absolute -inset-6 rounded-[32px] blur-3xl" style={{ background: glow }} aria-hidden="true" />
    <img src={src} alt={alt} data-testid={testid} className={`relative w-full h-auto rounded-[20px] border ${border}`} />
  </motion.div>
);

export const FandomPage = ({ f }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const a = f.accent;
  return (
    <main className="relative pt-28" data-testid={`${f.id}-page`}>
      <div className="fixed inset-0 -z-10" style={{ background: f.bgColor, backgroundImage: f.bgImage }}
        data-testid={`${f.id}-bg`} aria-hidden="true" />
      <section className="relative max-w-[1400px] mx-auto px-5 md:px-10 pt-10 pb-6 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <p className={`font-mono text-[11px] uppercase tracking-[0.28em] ${a.soft}`}>{f.name} · fan corner</p>
          <h1 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.92] tracking-tight" data-testid={`${f.id}-title`}>
            <RevealLines lines={[<>{f.heading[0]}</>, <em className={a.text}>{f.heading[1]}</em>]} />
          </h1>
          <p className="mt-6 max-w-lg text-purple-50/90 leading-relaxed">{f.intro}</p>
        </div>
        {f.cover && (
          <div className="lg:col-span-5">
            <Cover src={f.cover} alt={`${f.name} poster`} glow={a.glow} border={a.border} testid={`${f.id}-cover`} />
          </div>
        )}
      </section>
      <FandomQuiz id={`${f.prefix}-quiz`} prefix={f.prefix} label={f.quizLabel} lines={f.quizLines}
        intro={f.quizIntro} quiz={f.quiz} accent={a} charm={f.charm}>
        <CharacterGallery characters={f.quiz.CHARACTERS} prefix={`${f.prefix}-gallery`} accentText={a.text} accentSoft={a.soft}
          blurb="Every character from the quiz, in their own colors. Pick one and make it yours for $10."
          cardClass={a.card} charm={f.charm} />
        <PairSets pairs={f.pairs} characters={f.quiz.CHARACTERS} fandom={f.name} prefix={`${f.prefix}-pairs`} accent={a} charm={f.charm} />
      </FandomQuiz>
    </main>
  );
};
